import { Compagnia } from './compagnia';
import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';

export class Ispettorato extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "ispettorati";

  nome: string;
  codice: string;
  compagnia: Compagnia;

  partita_iva: any;
  codice_fiscale: any;

  deserialize(input: any): Ispettorato {
    let retV: Ispettorato = new Ispettorato();
    retV = super.deserialize(input) as Ispettorato;

    if (input?.compagnia) {
      retV.compagnia = new Compagnia().deserialize(input.compagnia);
    }


    return retV;
  }

}
